import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface DoorsProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Doors: React.FC<DoorsProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [doors, setDoors] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Interior Features']?.['Doors'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Interior Features': { ...s.values?.['Interior Features'], Doors: v } } })
    );
    const label = 'Doors';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={doors}
                />
            ) : (
                <TextBox
                    value={doors ?? ''}
                    onChange={(value) => setDoors(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
